import { assign, find } from 'lodash'

import HTTP from '@/common/HTTP'
import { mutationTypes, actionTypes } from './AuditObjectsTypes'

function initialState() {
  return {
    items: [],
    editedItem: null,
    loading: false,
  }
}

const mutations = {
  [mutationTypes.SET_AUDIT_OBJECTS](state, items) {
    state.items = items
  },

  [mutationTypes.SET_EDITED_AUDIT_OBJECT](state, auditObject) {
    state.editedItem = auditObject
  },

  [mutationTypes.SET_AUDIT_OBJECT](state, auditObject) {
    assign(find(state.items, { id: auditObject.id }), auditObject)
  },

  [mutationTypes.SET_LOADING](state, value) {
    state.loading = value
  },

}

const actions = {
  [actionTypes.FETCH_AUDIT_OBJECTS]({ commit }) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.get('/audit-objects').then(({ data: { content } }) => {
      commit(mutationTypes.SET_AUDIT_OBJECTS, content)
      commit(mutationTypes.SET_LOADING, false)
    })
  },

  [actionTypes.CREATE_AUDIT_OBJECT]({ commit }, auditObject) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.post('/audit-objects', auditObject).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      commit(mutationTypes.SET_EDITED_AUDIT_OBJECT, null)
    })
  },

  [actionTypes.DELETE_AUDIT_OBJECT]({ commit, dispatch }, auditObject) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.delete(`/audit-objects/${auditObject.id}`).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      dispatch(actionTypes.FETCH_AUDIT_OBJECTS)
    })
  },

  [actionTypes.UPDATE_AUDIT_OBJECT]({ commit }, auditObject) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.patch(`/audit-objects/${auditObject.id}`, auditObject).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      commit(mutationTypes.SET_EDITED_AUDIT_OBJECT, null)
      commit(mutationTypes.SET_AUDIT_OBJECT, auditObject)
    })
  }


}

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/AuditObjects.js